const runtimeOrigin = typeof window !== "undefined" ? window.location.origin : "";

// Jika env URL dikosongkan, satu build AKAS dapat dipakai oleh semua domain tenant.
export const BASE_URL = process.env.REACT_APP_API_URL || `${runtimeOrigin}/api`;
export const BASE_URL_STORAGE =
  process.env.REACT_APP_BASE_URL_STORAGE || `${runtimeOrigin}/storage/`;
export const ENV_NAME = process.env.REACT_APP_ENV;
export const OPTION_TYPE_ACCESS = [
  {
    label: "view",
    value: "view",
    color: "bg-primary-lt",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="icon icon-tabler icons-tabler-outline icon-tabler-eye">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
        <path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" />
      </svg>
    ),
  },
  {
    label: "create",
    value: "create",
    color: "bg-success-lt",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="icon icon-tabler icons-tabler-outline icon-tabler-plus">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M12 5l0 14" />
        <path d="M5 12l14 0" />
      </svg>
    ),
  },
  {
    label: "edit",
    value: "edit",
    color: "bg-warning-lt",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="icon icon-tabler icons-tabler-outline icon-tabler-pencil">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 0 0 -4 -4l-10.5 10.5v4" />
        <path d="M13.5 6.5l4 4" />
      </svg>
    ),
  },
  {
    label: "Konfirmasi / Proses",
    value: "process",
    color: "bg-primary-lt",
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="icon"><path d="m5 12 4 4 10-10" /></svg>,
  },
  {
    label: "delete",
    value: "delete",
    color: "bg-danger-lt",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="icon icon-tabler icons-tabler-outline icon-tabler-trash">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M4 7l16 0" />
        <path d="M10 12l4 0" />
        <path d="M10 16l4 0" />
        <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
        <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
      </svg>
    ),
  },
];
export const ALERT_CONFIG = {
  success: {
    statusClass: "bg-success",
    iconColor: "#059669",
    bgIcon: "#0596681c",
    color: "#059669",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="icon icon-tabler icons-tabler-outline icon-tabler-check">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M5 12l5 5l10 -10" />
      </svg>
    ),
  },
  error: {
    statusClass: "bg-danger",
    iconColor: "#dc2626",
    bgIcon: "#dc26261c",
    color: "#dc2626",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ color: "#dc2626" }}
        className="icon icon-tabler icons-tabler-outline icon-tabler-alert-triangle">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M12 9v4" />
        <path d="M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0" />
        <path d="M12 16h.01" />
      </svg>
    ),
  },
  warning: {
    statusClass: "bg-warning",
    iconColor: "#d97706",
    bgIcon: "#d977061c",
    color: "#d97706",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ color: "#d97706" }}
        className="icon icon-tabler icons-tabler-outline icon-tabler-exclamation-mark">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M12 19v.01" />
        <path d="M12 15v-10" />
      </svg>
    ),
  },
  info: {
    statusClass: "bg-info",
    iconColor: "#0284c7",
    bgIcon: "#0284c71c",
    color: "#0284c7",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ color: "#0284c7" }}
        className="icon icon-tabler icons-tabler-outline icon-tabler-info-small">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M12 9h.01" />
        <path d="M11 12h1v4h1" />
      </svg>
    ),
  },
};
export const STYLE_SELECT = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#059669" // warna saat dipilih (active)
      : state.isFocused
        ? "#a7f3d0" // warna saat hover
        : "#ffffff", // default
    color: state.isSelected ? "#ffffff" : state.isFocused ? "#000000" : "#000000",
    cursor: "pointer",
  }),
  control: (base, state) => ({
    ...base,
    paddingLeft: "2rem", // beri ruang untuk ikon
    border: "none",
    borderRadius: "8px",
    boxShadow: "none",
    minHeight: "38px",
    "&:hover": {
      border: "none",
      boxShadow: "none",
    },
    backgroundColor: state.isDisabled ? "#F9FAFB" : "inherit",
    color: state.isDisabled ? "#F9FAFB" : "inherit",
    opacity: state.isDisabled ? 1 : 1,
    cursor: state.isDisabled ? "not-allowed" : "pointer",
  }),
  singleValue: (base, state) => ({
    ...base,
    color: state.isDisabled ? "#6D727F" : "inherit",
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "#e3f2fd", // soft light blue
    borderRadius: "20px",
    padding: "2px 8px",
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: "#000000", // soft blue text
    fontWeight: "500",
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: "#000000",
    ":hover": {
      backgroundColor: "#bbdefb", // hover soft blue
      color: "#a7f3d0",
    },
  }),
  // list dropdown style
  menu: (base) => ({
    ...base,
    zIndex: 2,
  }),
  placeholder: (base) => ({
    ...base,
    color: "#90a4ae", // muted blue-gray
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 99999, // kasih zIndex tinggi biar selalu di atas
  }),
};
